import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import useReveal from "../../hooks/useReveal";
import { apiGet } from "../../lib/api";

export default function BlogTeaser() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    let cancelled = false;
    apiGet("/blog/posts", { expectArray: true }).then((data) => {
      if (!cancelled && data) setPosts(data.slice(0, 3));
    });
    return () => { cancelled = true; };
  }, []);

  // Re-attach reveal observers once posts have rendered, so the section
  // doesn't appear as empty space below testimonials.
  useReveal([posts.length]);

  if (!posts.length) return null;

  return (
    <section data-testid="blog-teaser-section" className="py-24 md:py-32 bg-[#F8F5EF]">
      <div className="container-x">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-12 md:mb-16">
          <div className="md:col-span-7 reveal">
            <div className="flex items-center gap-3 mb-6">
              
              <span className="overline">Ratgeber & Blog</span>
            </div>
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[1.02] text-[#1A1A1A] tracking-tight">
              Wissen, das <br />
              Immobilien <span className="gold-text italic">verkauft</span>.
            </h2>
          </div>
          <div className="md:col-span-4 md:col-start-9 md:flex md:items-end md:justify-end reveal">
            <Link
              to="/blog"
              data-testid="blog-teaser-all-link"
              className="group inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#1A1A1A] link-underline"
            >
              Alle Beiträge
              <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:rotate-45" />
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {posts.map((p, i) => (
            <Link
              key={p.slug}
              to={`/blog/${p.slug}`}
              data-testid={`blog-teaser-card-${p.slug}`}
              className={`group block reveal ${i === 1 ? "md:mt-12" : ""}`}
            >
              <div className="img-hover aspect-[4/3] overflow-hidden mb-5">
                <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover" />
              </div>
              <div className="flex items-center gap-3 text-[10px] uppercase tracking-[0.2em]">
                <span className="gold-text">{p.category}</span>
                <span className="w-4 h-px bg-[#EAE6DE]"></span>
                <span className="text-[#5A5A5A]">{p.read_time}</span>
              </div>
              <h3 className="mt-3 font-display text-2xl md:text-[26px] leading-tight text-[#1A1A1A] group-hover:text-[#FFA500] transition-colors tracking-tight">
                {p.title}
              </h3>
              <p className="mt-3 text-[14px] leading-relaxed text-[#5A5A5A] font-light line-clamp-3">
                {p.excerpt}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
